import React, { useContext } from "react"

import { Form, Formik } from "formik"
import { gql, useQuery } from "urql"

import { Button } from "~tailwindui/Basics"
import Modal from "~tailwindui/Modal"

import { surveyOptionsWithIcons } from "src/enums"
import ordered from "src/ordered"

import { RadioField } from "components/Forms/Formik/hookComponents"
import UrqlLoadingIndicator from "components/WithLoadingIndicator/urql"

import CloudroomContext from "../CloudroomContext"

const TutorSurveyModal = () => {
  const { session, surveyOpen, setSurveyOpen } = useContext(CloudroomContext)

  const [result] = useQuery({
    query: surveyQuery,
    variables: { sessionId: session.id },
  })

  if (!surveyOpen) return null
  return (
    <Modal.Dialog
      hideButton
      isOpen={surveyOpen}
      closeModal={() => setSurveyOpen(false)}
    >
      <Modal.Header>Student Survey</Modal.Header>
      <Modal.Body>
        <UrqlLoadingIndicator result={result}>
          {({ data: { airtutorsSession } }) => (
            <div className="modal-body">
              <div className="alert mb-2 rounded bg-yellow-400 p-3 text-black">
                <p className="text-left">
                  This survey is currently being presented to any students who
                  have not yet completed it. Please ensure all students complete
                  the form. You may read the questions aloud to them if
                  necessary.
                </p>
                <br />

                {airtutorsSession.missingSurveyStudents.length > 0 ? (
                  <div className="text-left">
                    The following students have not yet completed the survey:
                    <ul className="m-0">
                      {ordered(
                        airtutorsSession.missingSurveyStudents,
                        "fullName"
                      ).map(student => (
                        <li key={student.id}>{student.fullName}</li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  "All students have completed the survey."
                )}
              </div>

              {airtutorsSession.survey.questions.map((question, index) => (
                <div
                  key={question.id}
                  className="mb-4 border-0 border-b-2 border-solid border-b-slate-200"
                >
                  <label className="mb-4 block text-xl">{question.text}</label>
                  <Formik initialValues={{}} onSubmit={() => undefined}>
                    <Form>
                      <RadioField
                        name={`answers[${index}][value]`}
                        options={surveyOptionsWithIcons}
                        numeric
                        disabled
                      />
                    </Form>
                  </Formik>
                </div>
              ))}
            </div>
          )}
        </UrqlLoadingIndicator>
      </Modal.Body>

      <Modal.Footer>
        <div className="flex justify-center">
          <Button onClick={() => setSurveyOpen(false)}>
            Close this window
          </Button>
        </div>
      </Modal.Footer>
    </Modal.Dialog>
  )
}

const surveyQuery = gql`
  query SessionSurvey($sessionId: ID!) {
    airtutorsSession(id: $sessionId) {
      id
      survey {
        id
        questions {
          id
          text
        }
      }
      missingSurveyStudents {
        id
        fullName
      }
      surveyAnswers {
        id
        student {
          id
        }
      }
      students {
        id
        fullName
      }
    }
  }
`

export default TutorSurveyModal
